import request from '@/utils/request';
const api = {
  UserInfo: '/user/getUserInfo',
  UserName: '/user/name',
  Login: '/login',
  ResetPwd: '/findPassword',
  UploadToken: '/getToken',
  GetCate: '/tool/cate',
  GetTag: '/tag/tagList',
  AddTag: '/addTag',
  DeleTag: 'tag/delete',
  GetIndustry: '/industry',
  GetRegoin: '/regoin',
  regionTree: '/regionTree',
  AddVRImg: '/add/pic',
  GetMaterial: '/pano/list',
  UpdatePassword: '/user/edit/passwrod',
  UserEdit: '/user/edit',
  SysSet: '/admin/sys/base',
  SysConfig: '/sys/config',
  StorageZone: '/admin/sys/storagezone',
  LogOut: '/logout',
  PageQuery: '/user/userlist',
  DealerQueryAll: '/user/dealerAll',
  CreateUser: '/user/userCreate',
  CreateDealer: '/user/dealerCreate',
  DeleteUser: '/user/delete',
  SoftDelete: '/user/softDelete',
  Recycle: '/user/recycle',
  UserRestore: '/user/restore',
  UserDetail: '/user/detail',
  DealerPageQuery: '/user/dealerList',
  AddPano: '/pano/addpano',
  Regiser: '/regiser',
  DistributionCapacity: '/user/distributionCapacity',
  SetCapacity: '/user/setCapacity',
  SetPoint: '/User/setPoint',
  DateStatist: '/visit/statisticsByDate',
  ProvinceStatist: '/visit/statisticsByProvince',
  visitPStatist: '/visit/statisticsByProvince',
  workPStatist: '/work/statisticsByProvince',
  workStatistByDate: '/work/statisticsByDate',
  vistByDate: '/visit/statisticsByDate',
  loginRecordByDate: '/user/loginStatisticsByDate',
  userAddCount: '/user/statisticsAddUser',
  ChangeAuthority: '/user/changeAuthority',
  GetBaseSiteConfig: '/getBaseSiteConfig',
  Recommend: '/user/recommend',
  QueryUserRecommend: '/queryUserRecommend',
  sendSms: '/sendSms',
  payLevel: '/pay/level',
  getPayAmount: 'pay/getPayAmount',
  resetPassword: '/user/resetPassword',
  getStorageFee: 'pay/getStorageFee',
  payDilatationStorage: 'pay/dilatationStorage',
  pageQueryWork: '/pageQueryWork',
  pageQueryUser: '/pageQueryUser',
  getArticleSubCates: '/getArticleSubCates',
  pageQueryArticle: '/pageQueryArticle',
  articleDetail: '/articleDetail',
  userDetail: '/userDetail',
  queryBottomNav: '/queryBottomNav',
  addArticleVisits: '/addArticleVisits',
  CheckHbhousing: '/user/checkHbhousing',
  clearNotice: '/user/clearNotice',
  addUserLoginHistory: '/user/addUserLoginHistory',
};
export default api;
export function saveSiteConfig(data) {
  return request({
    url: api.SysSet,
    method: 'post',
    data,
  });
}
export function getSiteConfig() {
  return request({
    url: api.SysConfig,
    method: 'post',
  });
}
export function getBaseSiteConfig() {
  return request({
    url: api.GetBaseSiteConfig,
    method: 'post',
  });
}
export function sendSms(data) {
  return request({
    url: api.sendSms,
    method: 'post',
    data,
  });
}
export function payLevel(data) {
  return request({
    url: api.payLevel,
    method: 'post',
    data,
  });
}

export function getPayAmount() {
  return request({
    url: api.getPayAmount,
    method: 'post',
  });
}

export function getStorageFee() {
  return request({
    url: api.getStorageFee,
    method: 'post',
  });
}

export function payDilatationStorage(data) {
  return request({
    url: api.payDilatationStorage,
    method: 'post',
    data,
  });
}

export function pageQueryWork(data) {
  return request({
    url: api.pageQueryWork,
    method: 'post',
    data,
  });
}

export function pageQueryUser(data) {
  return request({
    url: api.pageQueryUser,
    method: 'post',
    data,
  });
}

export function getCate() {
  return request({
    url: api.GetCate,
    method: 'get',
  });
}

export function getArticleSubCates(params) {
  return request({
    url: api.getArticleSubCates,
    method: 'get',
    params,
  });
}

export function pageQueryArticle(data) {
  return request({
    url: api.pageQueryArticle,
    method: 'post',
    data,
  });
}

export function articleDetail(params) {
  return request({
    url: api.articleDetail,
    method: 'get',
    params,
  });
}

export function userDetail(params) {
  return request({
    url: api.userDetail,
    method: 'get',
    params,
  });
}

export function queryBottomNav() {
  return request({
    url: api.queryBottomNav,
    method: 'post',
  });
}

export function addArticleVisits(data) {
  return request({
    url: api.addArticleVisits,
    method: 'post',
    data,
  });
}
